import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);

  // If we already have a valid authn JWT, allow navigation
  if (authService.isAuthenticated()) {
    return true;
  }

  // No valid token — kick off Cognito authentication.
  // Return a promise that never resolves so Angular keeps the route in a
  // "loading" state while the browser redirects to the Cognito hosted UI.
  // If Cognito returns a valid session (user was already logged in via SSO),
  // we exchange for an authn JWT and resolve true.
  return new Promise<boolean>((resolve) => {
    authService.checkAndAuthenticate().then((authenticated) => {
      if (authenticated) {
        resolve(true);
      }
      // If not authenticated, checkAndAuthenticate already triggered a redirect
      // to Cognito. Don't resolve — let the redirect happen.
    });
  });
};
